import Modal from './Modal';
import * as ModalStyles from './Modal.styles';

export default Modal;

export { ModalStyles };
